<template>
  <div v-loading="loading">
    <div class="rj-flex delivery">
      <div class="rj-flex__item">
        <p class="title">
          交付说明：
        </p>
        <p>1、订单完成的30分钟之后，您可在线查询“约定交付日期”；如“约定交付日期”为空白，请在第二个工作日中午12点之后查询；如紧急要货订单，请对具体型号进行勾选、加急，交付日期如有变化时，系统会给您发邮件通知；在整单备齐时，系统会给您邮件通知。</p>
        <p>2、期望发货日期如有提前，请您提前15天通知锐捷商务或销售。</p>
      </div>
      <div style="width:250px;text-align: right;">
        <el-button type="primary" @click="attention">
          加急
        </el-button>
        <el-button type="default" :loading="exportLoading" @click="exportData">
          导出
        </el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
      <!--<el-table-column type="selection" width="55" align="left" />-->
      <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
      <el-table-column prop="orderNumber" label="订单号" align="left" />
      <el-table-column prop="productCode" label="物品代码" align="left" />
      <el-table-column prop="productName" label="商品名称" align="left" />
      <el-table-column prop="unshippedCount" label="未发货数量" align="left" />
      <!--      <el-table-column prop="orderPrice" label="订单单价" align="left" />-->
      <el-table-column prop="customerDate" label="客户期望发货日" align="left" />
      <el-table-column prop="agreedDate" label="预约交付日期" align="left" />
      <!-- <el-table-column prop="reason" label="待定原因" align="left" />
      <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
    </el-table>
  </div>
</template>
<script type="es6">
import axios, { getAgreedDeliveryDate, postInterestDeliveryDate } from '@/API';

export default {
  data () {
    return {
      tableData: [],
      multipleSelection: [],
      loading: false,
      exportLoading: false
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {},
  computed: {},
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    attention () {
      let lineIdGroup = [];
      this.tableData.forEach((item) => {
        if (item.orderRowId) {
          lineIdGroup.push(item.orderRowId);
        }
      });
      let params = {
        userId: this.$store.state.user.userId,
        userName: this.$store.state.user.userName,
        oddNumbers: this.tableData[0].orderNumber,
        lineIdGroup: lineIdGroup
      };
      postInterestDeliveryDate(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success('已成功标记为加急项！');
        }
      }).catch((res) => {

      });
    },
    exportData () {
      this.exportLoading = true;
      axios.get('/export/exportDeliverDate?strContractCode=' + this.strContractCode, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '导出约定交付日期产品列表.xls';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    initData () {
      this.loading = true;
      getAgreedDeliveryDate(this.strContractCode).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss">
  @import "../../../../style/var";
  .delivery{
    align-items: center;
    margin-bottom: 20px;
    color: $--color-text-regular;
    line-height: 28px;
    .title{
      color: $primaryColor;
    }
  }
</style>
